<app-banner [loading]="loading" [info]="true" heading="Diagnostics" subHeading="View logs and environment details">
</app-banner>

<div class="content spread">
  @if (!loading) {
    <div class="row">
      <div class="col-lg-7 left-col">
        <section>
          <h2>Logs</h2>
          @for (log of logs; track log) {
            <div>
              <div class="log row table-row" (click)="log.expanded = !log.expanded" [class.clickable]="!!log.data.length" [class.info]="log.level===0"
                [class.error]="log.level>1">
                <div class="col-" style="color:#999;min-width:110px">
                  {{ log.date | time }}
                </div>
                <div class="col-" style="flex-grow:1">
                  @if (log.data.length) {
                    <i class="fa fa-plus pull-right" style="padding-top:5px;padding-right:5px"></i>
                  }
                  {{ log.text }}
                </div>
              </div>
              <app-collapsible [trigger]="log.expanded" class="row table-row">
                @for (item of log.data; track item) {
                  <pre class="col-12">{{ item | json }}</pre>
                }
              </app-collapsible>
            </div>
          }
        </section>
      </div>
      <div class="col-lg-5 right-col">
        <section>
          <h2>Environment</h2>
          <table class="table-horizontal">
            <tr>
              <td>Version</td>
              <td>{{ environment.version }}</td>
            </tr>
            <tr>
              <td>Target</td>
              <td>{{ environment.target.toUpperCase() }}</td>
            </tr>
          </table>
        </section>
        @if (user) {
          <section>
            <h2>User</h2>
            <table class="table-horizontal">
              <tr><td>Name</td><td>{{ user.profile.name }}</td></tr>
              <tr><td>Email</td><td>{{ user.userName }}</td></tr>
            </table>
          </section>
        }
      </div>
    </div>
  }
</div>